/** Editable vector masters. All world textures originate here, without remote assets. */
const ink = '#352b32';
const wrap = (body: string, view = '0 0 260 200') => `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${view}" width="260" height="200"><g stroke="${ink}" stroke-width="3" stroke-linejoin="round" stroke-linecap="round">${body}</g></svg>`;
const ellipse = (x: number, y: number, rx: number, ry: number, fill: string) => `<ellipse cx="${x}" cy="${y}" rx="${rx}" ry="${ry}" fill="${fill}"/>`;
const rect = (x: number, y: number, w: number, h: number, fill: string, r = 5) => `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="${r}" fill="${fill}"/>`;
const path = (d: string, fill: string) => `<path d="${d}" fill="${fill}"/>`;
const shadow = `<ellipse cx="130" cy="173" rx="98" ry="18" fill="#352b32" opacity=".13" stroke="none"/>`;

export function objectArt(id: string): string {
  let b = shadow;
  switch (id) {
    case 'bessie':
      b += rect(67, 133, 19, 40, '#fff4d8') + rect(166, 133, 19, 40, '#fff4d8');
      b += ellipse(122, 109, 76, 49, '#fff4d8') + path('M64 79Q96 65 101 96Q101 121 70 119Z', '#9d6947') + ellipse(153, 106, 21, 25, '#9d6947');
      b += path('M51 106Q24 119 38 143', 'none') + ellipse(185, 82, 13, 8, '#c99c79') + ellipse(231, 83, 13, 8, '#c99c79');
      b += rect(184, 73, 48, 66, '#fff4d8', 21) + ellipse(208, 126, 27, 17, '#e2a89c');
      b += ellipse(198, 100, 2, 4, ink) + ellipse(221, 100, 2, 4, ink) + ellipse(198, 128, 2, 2, ink) + ellipse(217, 128, 2, 2, ink);
      b += path('M191 77l-4-14 12 9M220 73l12-10-3 17', '#f3c655');
      break;
    case 'hay1':
      b += rect(64, 80, 132, 82, '#d9aa49', 17) + ellipse(74, 120, 27, 41, '#f3d87b');
      b += path('M113 81v79M171 81v79M65 99l15 39M57 114l24 3M91 97l-20 50M129 94h27M127 145h30', 'none');
      break;
    case 'trough':
      b += path('M40 108L133 74 224 111 203 158 127 183 53 149Z', '#9d6947') + path('M42 107l87 38 95-34-91-37Z', '#e4cfab');
      b += path('M61 110l65 25 76-24-67-24Z', '#829a68') + path('M75 113l18-8m23 12 14-12m23 5 16-5M128 145v34', 'none');
      break;
    case 'vat':
      b += rect(72, 140, 15, 36, '#9d6947') + rect(176, 140, 15, 36, '#9d6947') + rect(46, 71, 168, 86, '#82a8b2', 29);
      b += ellipse(130, 72, 84, 33, '#afcbd0') + ellipse(130, 72, 68, 24, '#fff4d8');
      b += path('M61 100v29Q65 145 90 146M197 112h22v25h-16', 'none') + ellipse(133, 126, 17, 17, '#f3c655') + ellipse(133, 126, 12, 12, '#fff4d8') + path('M133 126l7-7', 'none');
      b += path('M90 66l63 17', 'none');
      break;
    case 'table':
      b += path('M45 104v56l10 4v-53M201 107v56l11-4v-54M127 140v45l12-3v-47', '#9d6947');
      b += path('M29 97l97-44 107 42-99 48Z', '#c99c79') + path('M29 97v12l105 46 99-46V95l-99 48Z', '#9d6947');
      b += path('M55 94l68-27 73 29-65 28Z', '#fff4d8');
      b += path('M85 88l40 15m-24-24 40 16', 'none');
      break;
    case 'tub':
      b += path('M53 95l15 63Q132 193 197 158l12-63Z', '#82a8b2') + ellipse(131, 95, 78, 35, '#afcbd0') + ellipse(131, 96, 64, 24, '#d9e9df');
      b += path('M92 95q13-8 24 0m17 8q14-8 29 0M77 129v22', 'none');
      break;
    case 'rack_west': case 'rack_east':
      b += rect(47, 24, 165, 150, '#73523c') + rect(60, 36, 139, 126, '#443e43');
      for (let i = 0; i < 3; i++) b += rect(51, 60 + i * 42, 158, 10, '#c99c79');
      b += rect(44, 22, 13, 163, '#9d6947') + rect(205, 22, 13, 163, '#9d6947');
      break;
    case 'dials':
      b += rect(49, 57, 162, 105, '#afcbd0', 14) + rect(61, 68, 138, 81, '#829ba7', 10);
      b += ellipse(99, 104, 26, 26, '#f3c655') + ellipse(99, 104, 20, 20, '#fff4d8') + ellipse(162, 104, 26, 26, '#f3c655') + ellipse(162, 104, 20, 20, '#fff4d8');
      b += path('M99 104l-8-11M162 104l12-8M94 137h10m52 0h12', 'none');
      break;
    case 'board':
      b += rect(66, 135, 13, 49, '#9d6947') + rect(181, 135, 13, 49, '#9d6947') + rect(45, 29, 170, 119, '#9d6947') + rect(56, 39, 148, 95, '#466955');
      b += rect(69, 57, 48, 57, '#fff4d8', 2) + rect(132, 57, 53, 57, '#fff4d8', 2) + ellipse(93, 57, 3, 3, '#f3c655') + ellipse(156, 57, 3, 3, '#f3c655');
      b += path('M81 78h22M81 88h17M144 78h28M144 88h19', 'none');
      break;
    case 'desk':
      b += rect(53, 102, 155, 70, '#9d6947') + path('M39 95l91-37 93 38-93 41Z', '#c99c79') + path('M130 137v34M67 134h41M67 149h41', 'none');
      b += path('M93 87l34-13 38 15-33 14Z', '#fff4d8') + path('M128 76l4 24', 'none') + rect(172, 76, 21, 29, '#afcbd0');
      break;
    case 'spaceship':
      b += path('M53 147l-14 32 39-16M195 147l22 31-4-41', '#9d6947') + ellipse(130, 123, 111, 41, '#829ba7') + ellipse(130, 111, 110, 32, '#afcbd0');
      b += path('M74 102Q77 32 130 30Q186 35 187 104Z', '#62b8ae') + path('M94 79Q105 48 132 47', 'none') + path('M168 92l-17 14 17 15-9 17', '#57566a');
      for (let x = 52; x < 220; x += 35) b += ellipse(x, 125, 7, 5, '#f3c655');
      break;
    case 'field_terminal':
      b += path('M104 120l-8 45h66l-9-45', '#829ba7') + rect(69, 43, 121, 93, '#afcbd0', 17) + rect(81, 55, 96, 56, '#352b32', 10);
      b += path('M110 89l18-22 19 22-19 12Z', '#9274be') + ellipse(107, 122, 4, 4, '#f3c655') + ellipse(129, 122, 4, 4, '#62b8ae') + ellipse(153, 122, 4, 4, '#c97943');
      break;
    case 'pasture':
      b += path('M27 131l100-54 107 52-98 57Z', '#829a68');
      for (let i = 0; i < 5; i++) { const x = 54 + i * 31; b += path(`M${x} 115v-41m0 18 30-12`, 'none'); }
      b += path('M86 134l-5-10m5 10 8-8M152 147l3-12m-3 12-8-7', 'none');
      b += ellipse(119, 114, 5, 5, '#fff4d8') + ellipse(119, 114, 2, 2, '#f3c655');
      break;
    default: b += rect(70, 60, 120, 110, '#c99c79');
  }
  return wrap(b);
}

export function mouseArt(role: string, facing: string): string {
  const back = ['n', 'ne', 'nw'].includes(facing), profile = ['e', 'w'].includes(facing);
  const fur = role === 'player' ? '#c49a7c' : role === 'cellar' ? '#a89cab' : '#c6b39a';
  const apron = role === 'barn' ? '#c99c79' : role === 'cellar' ? '#9274be' : role === 'vat' ? '#afcbd0' : '#fff4d8';
  let b = path('M40 80Q12 95 13 73', 'none') + ellipse(43, 88, 9, 5, '#73523c') + ellipse(62, 88, 9, 5, '#73523c');
  b += ellipse(52, 65, 19, 24, fur) + path('M39 52l26 0 3 27Q51 88 35 78Z', apron);
  b += ellipse(profile ? 57 : 52, 37, 21, 19, fur) + ellipse(34, 20, 12, 12, fur) + ellipse(69, 20, 11, 11, fur);
  b += ellipse(34, 20, 7, 7, '#e2a89c') + ellipse(69, 20, 6, 6, '#e2a89c');
  if (!back) {
    b += ellipse(profile ? 72 : 52, 46, 9, 6, '#e4cfab');
    b += ellipse(profile ? 80 : 52, 43, 3, 2, '#73523c') + ellipse(profile ? 65 : 44, 35, 2, 3, ink);
    if (!profile) b += ellipse(61, 35, 2, 3, ink);
    b += path(profile ? 'M73 50h14M72 54l11 4' : 'M36 44l-10-3m10 7-10 2m41-6 10-3m-10 7 10 2', 'none');
  }
  b += ellipse(33, 66, 5, 8, fur) + ellipse(72, 66, 5, 8, fur);
  if (role === 'player' && !back) b += path('M47 64l10-4 3 10-13 0Z', '#f3c655');
  return `<svg xmlns="http://www.w3.org/2000/svg" width="104" height="100" viewBox="0 0 104 100"><g stroke="${ink}" stroke-width="2" stroke-linejoin="round" stroke-linecap="round">${b}</g></svg>`;
}
